// Centralized API Config Helper for SILKCare Frontend
// Default Server: Server Utama (http://202.155.94.169:7000)

export const MAIN_SERVER_URL = 'http://202.155.94.169:7000';

export const getApiUrl = () => {
  const saved = localStorage.getItem('apiUrl');
  // Jika tersimpan localhost atau belum diset, ganti otomatis ke Server Utama
  if (saved && saved.trim() && !saved.includes('localhost')) {
    return saved.trim().replace(/\/+$/, '');
  }
  localStorage.setItem('apiUrl', MAIN_SERVER_URL);
  return MAIN_SERVER_URL;
};

export const setApiUrl = (url) => {
  if (!url || !url.trim()) {
    localStorage.setItem('apiUrl', MAIN_SERVER_URL);
    return MAIN_SERVER_URL;
  }
  let formatted = url.trim();
  if (!formatted.startsWith('http://') && !formatted.startsWith('https://')) {
    formatted = 'http://' + formatted;
  }
  formatted = formatted.replace(/\/+$/, '');
  localStorage.setItem('apiUrl', formatted);
  return formatted;
};
